import React from 'react';

export interface DropdownMenuItem {
  key: string;
  iconClassName: string;
  label: string;
  onClick: () => void;
}

interface DropdownMenuProps {
  visible: boolean;
  items: DropdownMenuItem[];
  menuClassName: string;
  iconClassName: string;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
}

const DropdownMenu: React.FC<DropdownMenuProps> = ({
  visible,
  items,
  menuClassName,
  iconClassName,
  onMouseEnter,
  onMouseLeave,
}) => {
  return (
    <ul
      className={menuClassName}
      style={{ display: visible ? 'block' : 'none' }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {items.map(item => (
        <li key={item.key} onClick={item.onClick}>
          <i className={`iconFont ${item.iconClassName} ${iconClassName}`}></i>
          <span>{item.label}</span>
        </li>
      ))}
    </ul>
  );
};

export default DropdownMenu;
